//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NavAppBar from "./nav/appbar";
import Utils from "./utils/helper";
import ContentLayout from "./nav/content";
import phoenixSocketMixin from "./components/mixins/ws/phoenixSocket.js";
import actionCableMixin from "./components/mixins/ws/actionCable.js";
import FormPanel from "./components/panels/form";
export default {
  components: {
    "nav-appbar": NavAppBar,
    "layouts-content": ContentLayout,
    "panels-form": FormPanel
  },
  mixins: [phoenixSocketMixin, actionCableMixin],
  props: {
    page: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      title: "..."
    };
  },
  computed: {
    header: function header() {
      return this.page.header || {};
    },
    body: function body() {
      return this.page.body || {};
    },
    footer: function footer() {
      return this.page.footer || {};
    },
    containerComponent: function containerComponent() {
      if (this.formSpec) {
        return "panels-form";
      }

      return "div";
    },
    // Use computed to ensure that the spec gets updated when the user navigates to another page.
    formSpec: function formSpec() {
      return this.page.fullPageForm;
    }
  },
  watch: {
    "$root.indicator": function $rootIndicator(val, oldVal) {
      document.title = val ? "..." : this.page.title;
    }
  },
  created: function created() {
    console.log("Version: ".concat(Utils.settings.appVersion, " (").concat(Utils.settings.env, ")"));
    Utils.history.saveInitialContent(this.page);
    Utils.history.restoreOnBackOrForward();
    Utils.http.promptIfDirtyOnUnload();
  },
  methods: {
    $ready: function $ready() {
      var _this = this;

      document.title = this.page.title;
      this.$wsInitPhoenixSocket(this.page.phoenixSocket);
      this.$wsInitActionCable(this.page.actionCable);

      if (this.$gtag) {
        if (!Utils.settings.isDev) {
          console.log("Tracking analytics: ".concat(window.location));
          this.$gtag.pageview({
            page_location: window.location
          });
        }
      } else {
        console.warn("Analytics not setup. Set `settings.gtagId`.");
      }

      if (Utils.history.isPoppedState(this.page)) {
        setTimeout(function () {
          // Wait until page is rendered
          GLib.action.execute(_this.page.onRefocus, _this);
          GLib.action.execute(_this.page.replayGetResponse, _this);
        });
      } else {
        setTimeout(function () {
          // Wait until page is rendered
          GLib.action.execute(_this.page.onLoad, _this);
        });
      }
    }
  }
};